/**
 * The product cards pinned on the homepage — the innovations holding a homepage
 * slot in the CMS, in slot order. The bundled four are the offline fallback;
 * `siteContent.ts` replaces the list once the CMS has answered.
 */

import podusAiLogo from '@podus/ui/logo-icons/podus-ai.png';
import podusAidLogo from '@podus/ui/logo-icons/podus-aid.png';
import podusAppointmentLogo from '@podus/ui/logo-icons/podus-appointment.png';
import podusContractLogo from '@podus/ui/logo-icons/podus-contract.png';

export interface InnovationCard {
    /** Last segment of the product page URL; also the CMS record id. */
    slug: string;
    /** Name with the last word split off — "Podus " + "AI" — the card colours it. */
    name: string;
    accent: string;
    logo: string;
    href: string;
    cta: string;
    paragraph: string;
}

const CARD_PARAGRAPH =
    'Podus is an AI-powered super app transforming how people and businesses access legal solutions — from instant guidance to contract management and human rights protection.';

/** "Podus AI" → "Podus " + "AI"; a one-word name is all accent. */
export function nameParts(name: string): { name: string; accent: string } {
    const words = name.trim().split(/\s+/).filter(Boolean);
    if (words.length <= 1) return { name: '', accent: words[0] ?? '' };
    return { name: `${words.slice(0, -1).join(' ')} `, accent: words[words.length - 1] };
}

/** Button copy per product; anything the CMS adds beyond these reads "Learn More". */
export const CARD_CTA: Record<string, string> = {
    'podus-ai': 'Ask A Question',
    'podus-contract': 'Review A Contract',
    'podus-appointment': 'Book A Lawyer',
    'podus-legal-aid': 'Request Aid',
    'podus-checker': 'Run A Check',
    'podus-multidoor-court': 'Start A Case',
    'iris': 'Take The Screening',
};

export const HOME_INNOVATIONS: InnovationCard[] = [
    {
        slug: 'podus-ai',
        ...nameParts('Podus AI'),
        logo: podusAiLogo,
        href: '/innovations/podus-ai',
        cta: CARD_CTA['podus-ai'],
        paragraph: CARD_PARAGRAPH,
    },
    {
        slug: 'podus-contract',
        ...nameParts('Podus Contracts'),
        logo: podusContractLogo,
        href: '/innovations/podus-contract',
        cta: CARD_CTA['podus-contract'],
        paragraph: CARD_PARAGRAPH,
    },
    {
        slug: 'podus-appointment',
        ...nameParts('Podus Appointment'),
        logo: podusAppointmentLogo,
        href: '/innovations/podus-appointment',
        cta: CARD_CTA['podus-appointment'],
        paragraph: CARD_PARAGRAPH,
    },
    {
        slug: 'podus-legal-aid',
        ...nameParts('Podus Aid'),
        logo: podusAidLogo,
        href: '/innovations/podus-legal-aid',
        cta: CARD_CTA['podus-legal-aid'],
        paragraph: CARD_PARAGRAPH,
    },
];
